<template>
<div class="modal fade" id="modalFeatureEdit" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Valor da Feature.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group">
            <label>Valor sugerido </label>
            <input v-model.lazy="price" v-money="money" type="text" class="form-control" id="value" name="value" required />
            <small>Esse valor não irá alterar automaticamente a fatura, é apenas para controle interno</small>
            <span v-if="error.price" class="error-msg">{{error.price}}</span>
          </div>

          <!--            <div class="form-group">-->
          <!--              <label>Observações</label>-->
          <!--              <textarea v-model="featureEdit.notes" class="form-control" name="description"> </textarea>-->
          <!--            </div>-->
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="sendEdit()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Enviar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  VMoney
} from 'v-money'

export default {
  name: "modalFeatureEdit",
  props: ['objToModal'],
  directives: {
    money: VMoney
  },
  data() {
    return {
      loadingChange: false,
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      error: {
        price: '',
        totalEmployee: ''
      },
      featureEdit: {
        name: '',
        featureType: '',
        isActive: '',
        id: '',
        price: '',
        notes: '',
        random: '',
      },
      emitValue: null,
    }
  },
  watch: {
    objToModal: function (val) {
      this.featureEdit.featureType = val.featureType;
      this.featureEdit.id = val.id;
      this.featureEdit.isActive = val.isActive;
      this.featureEdit.name = val.name;
      this.featureEdit.price = val.price;
    },
    emitValue: function (val) {
      this.$emit('update:reloadFunction', val)
    }
  },
  methods: {
    closeModal() {
      $('#modalFeatureEdit').modal('toggle');
    },
    sendEdit() {
      this.error.price = "";

      if (this.price !== '') {
        this.featureEdit.price = this.price.replace("R$ ", "");
        this.featureEdit.random = Math.floor(Math.random() * 500);

        let copyObject = null;
        copyObject = {
          name: this.featureEdit.name,
          featureType: this.featureEdit.featureType,
          isActive: this.featureEdit.isActive,
          id: this.featureEdit.id,
          price: this.featureEdit.price,
          notes: this.featureEdit.notes,
          random: this.featureEdit.random,
        };
        this.emitValue = copyObject;

        this.closeModal();
      } else {
        if (!this.price)
          this.error.price = "Preencha um valor.";
      }
    }
  }
}
</script>

<style lang="scss">
#modalFeatureEdit {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalFeatureEdit.vue